import React, { useState, useEffect } from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Button, Badge, Table, Form, Row, Col } from "react-bootstrap";
import "./Css/ViewMaintenance.css";
import { BiArrowBack } from "react-icons/bi";
import {
  check_vaild_save,
  combiled_form_data,
  empty_form,
  formatDateStringdot,
  handleError,
  handleSuccess,
  handleSuccessSession,
} from "../CommonJquery/CommonJquery";
import {
  APL_LINK,
  server_post_data,
  get_maintainance_data,
  maintainance_car_data,
} from "../ServiceConnection/serviceconnection";
import { useParams } from "react-router-dom";
import { retrieveData } from "../LocalConnection/LocalConnection";
const MaintenaceDataModal = ({ showUpcomingModal, handleShowMainModal ,bookingdata}) => {
  const retrievedAdminId = retrieveData("admin_id");
  const { id } = useParams();
  const [currentStep, setCurrentStep] = useState(0);
  const [startDateMaintance, setStartDateMaintance] = useState(null);
  const [checked, setChecked] = useState("");
  const [checked1, setChecked1] = useState("");
  const [checked2, setChecked2] = useState("");
  const [otherChecked, setOtherChecked] = useState(false);
  const [damage, setDamage] = useState("");
  const [files, setFiles] = useState(null);
  const [otherValue, setOtherValue] = useState("");
  const [otherValue1, setOtherValue1] = useState("");
  const [otherValue2, setOtherValue2] = useState("");
  const [otherValue3, setOtherValue3] = useState("");
  const [otherValue4, setOtherValue4] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [selectedLight, setSelectedLight] = useState("");
  const [errors, seterrors] = useState("");
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [cardata, setcardata] = useState([]);
  const [ids, setids] = useState(0);
  const handleDamageChange = (event) => {
    setDamage(event.target.value);
    setFiles(null);
  };
  const handleFileChange = (event) => {
    setFiles(event.target.files);
  };

  const handleUploadClick = () => {
    document.getElementById("fileInput").click();
  };
  const handleDateChange = (date) => {
    setStartDateMaintance(date);
  };
  const handleNext = () => {
    if (currentStep < 7) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleOtherInputChange = (e) => {
    setOtherValue(e.target.value);
  };
  const handleCheckboxChangeother = (label) => {
    if (label === "Other") {
      setOtherChecked(!otherChecked);
      setChecked("");
    } else {
      setChecked(label);
      setOtherChecked(false);
    }
  };
  const handleCheckboxChangeother1 = (label) => {
    setChecked1(label);
    if (label !== "Other") {
      setOtherValue1("");
    }
  };
  const handleCheckboxChangeother2 = (label) => {
    setChecked2(label);
    if (label !== "Other") {
      setOtherValue2("");
    }
  };
  const handleChange = (value) => {
    setSelectedPerson(value);
    if (value !== "Other") {
      setOtherValue("");
    }
  };
  const handleChange1 = (value) => {
    setSelectedLight(value);
    if (value !== "Other") {
      setOtherValue(""); // Clear input when another option is selected
    }
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    console.log(vaild_data);
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      fd_from.append("main_id", ids);
      fd_from.append("currentStep", currentStep);
      fd_from.append("booking_id", id);
      fd_from.append("user_id", retrievedAdminId);
      fd_from.append("car_id", bookingdata.car_id);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            seterrors(Response.data.message);
            // handleError(Response.data.message);
          } else {
            
            if (ids === 0) {
              setids(Response.data.message.idsss);
            }
            if (currentStep < 7) {
              setCurrentStep(currentStep + 1);
            }
            handleSuccess(Response.data.message);
            if(currentStep === 7){
              currentStep = 0
              handleShowMainModal()
            }
            // empty_form(form_data);
            // setShowUpcomingModal(!showUpcomingModal);
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
    }
  };

  return (
    <div>

      <Modal
        show={showUpcomingModal}
        onHide={handleShowMainModal}
        centered
        size="xl"
        className="upcoming_modal"
        backdrop="static"
      >
        <Modal.Header closeButton style={{ position: "relative" }}>
          <Modal.Title>Maintenance Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="FormData">
            <div className="StepsDiv">
              <p>Step {currentStep + 1}/8</p>
            </div>
            <div className="row">
              {currentStep === 0 && (
                <>
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="date" className="d-flex flex-column">
                      <Form.Label>Date*</Form.Label>
                      <DatePicker
                        selected={startDateMaintance}
                        onChange={handleDateChange}
                        dateFormat="yyyy-MM-dd"
                        className="form-control "
                        id="date"
                        name="date"
                        placeholderText="Select a date"
                      />
                    </Form.Group>
                  </div>

                  {/* LP Number field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="lpNumber">
                      <Form.Label>LP # (if not, choose as New)*</Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control "
                        placeholder="Enter LP Number"
                        id="licence_plate"
                        name="licence_plate"
                      />
                    </Form.Group>
                  </div>
                  {/* Driver's Name and Issues field */}
                  <div className="col-md-12 mb-3">
                    <Form.Group controlId="driverDetails">
                      <Form.Label>
                        Ask Driver's Name and any issue with the car*
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Driver's Name & Issues"
                        className="form-control "
                        id="name_and_issue"
                        name="name_and_issue"
                      />
                    </Form.Group>
                  </div>
                  {/* Reason field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="reason">
                      <Form.Label>Reason*</Form.Label>
                      <Form.Check
                        label="Maintenance"
                        value="Maintenance"
                        type="radio"
                        name="maintenance_reasion"
                        id="maintenance_reasion"
                        className="form-control "
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                      />
                      <Form.Check
                        label="Repair"
                        value="Repair"
                        name="maintenance_reasion"
                        id="maintenance_reasion"
                        type="radio"
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                        className="form-control "
                      />
                      <Form.Check
                        label="Oil Level check only"
                        value="Oil Level check only"
                        name="maintenance_reasion"
                        type="radio"
                        id="maintenance_reasion"
                        className="form-control "
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                      />
                    </Form.Group>
                  </div>

                  {/* Done By field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="doneBy">
                      <Form.Label>Done By*</Form.Label>
                      <Row>
                        {[
                          "Roberto",
                          "Dar",
                          "Marcus",
                          "Kumar",
                          "Cheema",
                          "Stephan",
                          "Driver",
                          "Other",
                        ].map((name, index) => (
                          <Col key={name} md={4}>
                            <Form.Check
                              label={name}
                              value={name}
                              type="radio"
                              name="assign_staff_name"
                              id="assign_staff_name"
                              className="form-control "
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              checked={
                                checked === name ||
                                (name === "Other" && otherChecked)
                              }
                              onChange={() => handleCheckboxChangeother(name)}
                            />
                          </Col>
                        ))}
                      </Row>
                      {otherChecked && (
                        <Form.Control
                          type="text"
                          placeholder="Please specify"
                          id="assign_staff_name"
                          name="assign_staff_name"
                          className="form-control  mt-2"
                          // style={{ backgroundColor: "transparent", border: 'none' }}
                          value={otherValue}
                          onChange={handleOtherInputChange}
                        />
                      )}
                    </Form.Group>
                  </div>
                </>
              )}

              {currentStep === 1 && (
                <>
                  {/*--------------- Tail section------- */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <h6 className="margin_clss">TAIL LIGHTS</h6>
                      <div className="row">
                        {[
                          "Right",
                          "Left",
                          "Reverse Lights",
                          "Blinker Right",
                          "Blinker Left",
                        ].map((light) => (
                          <div key={light} className="col-md-12 mb-2">
                            <Form.Label>{light}</Form.Label>
                            <div className="d-flex gap-3">
                              <Form.Check
                                label="Good"
                                value="Good"
                                // name={`tailLight_${light}`}
                                type="radio"
                                name={
                                  light === "Right"
                                    ? "tail_right"
                                    : light === "Left"
                                    ? "tail_left"
                                    : light === "Reverse Lights"
                                    ? "tail_reverse_light"
                                    : light === "Blinker Right"
                                    ? "tail_binker_right"
                                    : "tail_binker_left"
                                }
                                id={
                                  light === "Right"
                                    ? "tail_right"
                                    : light === "Left"
                                    ? "tail_left"
                                    : light === "Reverse Lights"
                                    ? "tail_reverse_light"
                                    : light === "Blinker Right"
                                    ? "tail_binker_right"
                                    : "tail_binker_left"
                                }
                                className="form-control "
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                              />
                              <Form.Check
                                label="Need Bulb"
                                value="Need Bulb"
                                // name={`tailLight_${light}`}
                                type="radio"
                                name={
                                  light === "Right"
                                    ? "tail_right"
                                    : light === "Left"
                                    ? "tail_left"
                                    : light === "Reverse Lights"
                                    ? "tail_reverse_light"
                                    : light === "Blinker Right"
                                    ? "tail_blinker_right"
                                    : "tail_blinker_left"
                                }
                                id={
                                  light === "Right"
                                    ? "tail_right"
                                    : light === "Left"
                                    ? "tail_left"
                                    : light === "Reverse Lights"
                                    ? "tail_reverse_light"
                                    : light === "Blinker Right"
                                    ? "tail_blinker_right"
                                    : "tail_blinker_left"
                                }
                                className="form-control "
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                              />
                              <Form.Check
                                label="Need Repair"
                                value="Need Repair"
                                type="radio"
                                name={
                                  light === "Right"
                                    ? "tail_right"
                                    : light === "Left"
                                    ? "tail_left"
                                    : light === "Reverse Lights"
                                    ? "tail_reverse_light"
                                    : light === "Blinker Right"
                                    ? "tail_blinker_right"
                                    : "tail_blinker_left"
                                }
                                id={
                                  light === "Right"
                                    ? "tail_right"
                                    : light === "Left"
                                    ? "tail_left"
                                    : light === "Reverse Lights"
                                    ? "tail_reverse_light"
                                    : light === "Blinker Right"
                                    ? "tail_blinker_right"
                                    : "tail_blinker_left"
                                }
                                className="form-control "
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* FRONT LIGHTS section */}
                    <div className="col-md-6 mb-3">
                      <h6 className="margin_clss">FRONT LIGHTS</h6>
                      <div className="row">
                        {[
                          "Left Low",
                          "Right Low",
                          "Left High",
                          "Right High",
                          "Blinker Right",
                          "Blinker Left",
                        ].map((light) => (
                          <div key={light} className="col-md-12 mb-2">
                            <Form.Label>{light}</Form.Label>
                            <div className="d-flex gap-3">
                              <Form.Check
                                label="Good"
                                value="Good"
                                // name={`frontLight_${light}`}
                                type="radio"
                                name={
                                  light === "Left Low"
                                    ? "front_light_left_low"
                                    : light === "Right Low"
                                    ? "front_light_right_low"
                                    : light === "Left High"
                                    ? "front_light_left_high"
                                    : light === "Right High"
                                    ? "front_light_right_high"
                                    : light === "Blinker Right"
                                    ? "blinker_right"
                                    : "blinker_left"
                                }
                                id={
                                  light === "Left Low"
                                    ? "front_light_left_low"
                                    : light === "Right Low"
                                    ? "front_light_right_low"
                                    : light === "Left High"
                                    ? "front_light_left_high"
                                    : light === "Right High"
                                    ? "front_light_right_high"
                                    : light === "Blinker Right"
                                    ? "blinker_right"
                                    : "blinker_left"
                                }
                                className="form-control"
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                              />
                              <Form.Check
                                label="Need Bulb"
                                value="Need Bulb"
                                // name={`frontLight_${light}`}
                                type="radio"
                                name={
                                  light === "Left Low"
                                    ? "front_light_left_low"
                                    : light === "Right Low"
                                    ? "front_light_right_low"
                                    : light === "Left High"
                                    ? "front_light_left_high"
                                    : light === "Right High"
                                    ? "front_light_right_high"
                                    : light === "Blinker Right"
                                    ? "blinker_right"
                                    : "blinker_left"
                                }
                                id={
                                  light === "Left Low"
                                    ? "front_light_left_low"
                                    : light === "Right Low"
                                    ? "front_light_right_low"
                                    : light === "Left High"
                                    ? "front_light_left_high"
                                    : light === "Right High"
                                    ? "front_light_right_high"
                                    : light === "Blinker Right"
                                    ? "blinker_right"
                                    : "blinker_left"
                                }
                                className="form-control"
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                              />
                              <Form.Check
                                label="Need Repair"
                                value="Need Repair"
                                // name={`frontLight_${light}`}
                                type="radio"
                                name={
                                  light === "Left Low"
                                    ? "front_light_left_low"
                                    : light === "Right Low"
                                    ? "front_light_right_low"
                                    : light === "Left High"
                                    ? "front_light_left_high"
                                    : light === "Right High"
                                    ? "front_light_right_high"
                                    : light === "Blinker Right"
                                    ? "blinker_right"
                                    : "blinker_left"
                                }
                                id={
                                  light === "Left Low"
                                    ? "front_light_left_low"
                                    : light === "Right Low"
                                    ? "front_light_right_low"
                                    : light === "Left High"
                                    ? "front_light_left_high"
                                    : light === "Right High"
                                    ? "front_light_right_high"
                                    : light === "Blinker Right"
                                    ? "blinker_right"
                                    : "blinker_left"
                                }
                                className="form-control"
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Oil Added by Driver field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="oilAddedByDriver">
                      <Form.Label>Oil Added by Driver (Qt)*</Form.Label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        <Form.Check
                          inline
                          label="1"
                          value="1"
                          name="oli_added_by_driver"
                          type="radio"
                          checked={checked1 === "1"}
                          onChange={() => handleCheckboxChangeother1("1")}
                          className="form-control"
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="2"
                          value="2"
                          name="oli_added_by_driver"
                          type="radio"
                          checked={checked1 === "2"}
                          onChange={() => handleCheckboxChangeother1("2")}
                          className="form-control"
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="Other"
                          name="oli_added_by_driver"
                          type="radio"
                          checked={checked1 === "Other"}
                          onChange={() => handleCheckboxChangeother1("Other")}
                          className="form-control"
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />

                        {/* Input field for "Other" */}
                        {checked1 === "Other" && (
                          <Form.Control
                            type="text"
                            placeholder="Enter custom value"
                            value={otherValue1}
                            onChange={(e) => setOtherValue1(e.target.value)}
                            className="form-control "
                            style={{ width: "120px" }}
                          />
                        )}
                      </div>
                    </Form.Group>
                  </div>

                  {/* Days Ago field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="days_age">
                      <Form.Label>Days Ago*</Form.Label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        <Form.Check
                          inline
                          label="1"
                          value="1"
                          name="days_age"
                          type="radio"
                          checked={checked2 === "1"}
                          onChange={() => handleCheckboxChangeother2("1")}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="2"
                          value="2"
                          name="days_age"
                          type="radio"
                          checked={checked2 === "2"}
                          onChange={() => handleCheckboxChangeother2("2")}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="3"
                          value="3"
                          name="days_age"
                          type="radio"
                          checked={checked2 === "3"}
                          onChange={() => handleCheckboxChangeother2("3")}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="Other"
                          name="days_age"
                          type="radio"
                          className="form-control "
                          checked={checked2 === "Other"}
                          onChange={() => handleCheckboxChangeother2("Other")}
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        {checked2 === "Other" && (
                          <Form.Control
                            type="text"
                            placeholder="Enter custom value"
                            value={otherValue2}
                            onChange={(e) => setOtherValue2(e.target.value)}
                            className="form-control "
                            style={{ width: "120px" }}
                          />
                        )}
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}
              {currentStep === 2 && (
                <>
                  {/* Oil Level field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="oilLevel">
                      <Form.Label>Oil Level*</Form.Label>
                      <div>
                        <Form.Check
                          label="Good"
                          value="Good"
                          type="radio"
                          name="oil_level"
                          id="oil_level"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Low"
                          value="Low"
                          type="radio"
                          name="oil_level"
                          id="oil_level"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Very Low"
                          value="Very Low"
                          type="radio"
                          name="oil_level"
                          id="oil_level"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* Oil Quality field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="oilQuality">
                      <Form.Label>Oil Quality*</Form.Label>
                      <div>
                        <Form.Check
                          label="Clean"
                          value="Clean"
                          type="radio"
                          name="oil_quantity"
                          id="oil_quantity"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Little Dark"
                          value="Little Dark"
                          type="radio"
                          name="oil_quantity"
                          id="oil_quantity"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Dark"
                          value="Dark"
                          type="radio"
                          name="oil_quantity"
                          id="oil_quantity"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Change Next time"
                          value="Change Next time"
                          type="radio"
                          name="oil_quantity"
                          id="oil_quantity"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Changed"
                          value="Changed"
                          type="radio"
                          name="oil_quantity"
                          id="oil_quantity"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* Oil Added Quantity field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="oilAddedQuantity">
                      <Form.Label>Oil Added Quantity (Qt)*</Form.Label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        <Form.Check
                          inline
                          label="0"
                          value="0"
                          name="oil_added_quantity"
                          id="oil_added_quantity"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="0.5"
                          value="0.5"
                          name="oil_added_quantity"
                          id="oil_added_quantity"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="1"
                          value="1"
                          name="oil_added_quantity"
                          id="oil_added_quantity"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          value="2"
                          label="2"
                          name="oil_added_quantity"
                          type="radio"
                          id="oil_added_quantity"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="3"
                          value="3"
                          name="oil_added_quantity"
                          id="oil_added_quantity"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="4"
                          value="4"
                          name="oil_added_quantity"
                          id="oil_added_quantity"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          inline
                          label="5"
                          value="5"
                          name="oil_added_quantity"
                          id="oil_added_quantity"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* Oil Changed By field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="oilChangedBy">
                      <Form.Label>Oil Changed By*</Form.Label>
                      <div>
                        <Form.Check
                          label="Roberto"
                          value="Roberto"
                          name="oil_changed_by"
                          type="radio"
                          checked={selectedPerson === "Roberto"}
                          onChange={() => handleChange("Roberto")}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          value="Marcus"
                          label="Marcus"
                          name="oil_changed_by"
                          type="radio"
                          checked={selectedPerson === "Marcus"}
                          onChange={() => handleChange("Marcus")}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Cheema"
                          value="Cheema"
                          name="oil_changed_by"
                          type="radio"
                          checked={selectedPerson === "Cheema"}
                          onChange={() => handleChange("Cheema")}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Other"
                          value="Other"
                          name="oil_changed_by"
                          type="radio"
                          checked={selectedPerson === "Other"}
                          onChange={() => handleChange("Other")}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />

                        {/* Show input field if "Other" is selected */}
                        {selectedPerson === "Other" && (
                          <Form.Control
                            type="text"
                            placeholder="Enter name"
                            value={otherValue3}
                            onChange={(e) => setOtherValue3(e.target.value)}
                            className="form-control"
                            style={{ width: "150px", marginTop: "5px" }}
                          />
                        )}
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}

              {currentStep === 3 && (
                <>
                  {/* Tire AIR PRESSURE section */}
                  <div className="col-md-12 mb-3">
                    <h5>TIRE AIR PRESSURE WHEN CHECKED (35-40 PSI)</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th></th>
                            <th>35-40</th>
                            <th>&lt; 35</th>
                            <th>&lt; 30</th>
                            <th>&gt; 40</th>
                            <th>Leak</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            "Front Right",
                            "Front Left",
                            "Rear Left",
                            "Rear Right",
                          ].map((position) => (
                            <tr key={position}>
                              <td>{position}</td>
                              <td>
                                <Form.Check
                                  // name={`tirePressure_${position}`}
                                  value="35-40"
                                  type="radio"
                                  name={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                />
                              </td>
                              <td>
                                <Form.Check
                                  // name={`tirePressure_${position}`}
                                  value="35"
                                  type="radio"
                                  name={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                />
                              </td>
                              <td>
                                <Form.Check
                                  // name={`tirePressure_${position}`}
                                  value="30"
                                  type="radio"
                                  name={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                />
                              </td>
                              <td>
                                <Form.Check
                                  // name={`tirePressure_${position}`}
                                  value="40"
                                  type="radio"
                                  name={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                />
                              </td>
                              <td>
                                <Form.Check
                                  // name={`tirePressure_${position}`}
                                  value="Leak"
                                  type="radio"
                                  name={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_air_front_right"
                                      : position === "Front Left"
                                      ? "tire_air_front_left"
                                      : position === "Rear Left"
                                      ? "tire_air_rear_left"
                                      : "tire_air_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* TIRE TRADE section */}
                  <div className="col-md-12 mb-3">
                    <h5>TIRE TRADE</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th></th>
                            <th>100%</th>
                            <th>75%</th>
                            <th>50%</th>
                            <th>25%</th>
                            <th>Change</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            "Front Right",
                            "Front Left",
                            "Rear Left",
                            "Rear Right",
                          ].map((position) => (
                            <tr key={position}>
                              <td>{position}</td>
                              <td>
                                <Form.Check
                                  value="100"
                                  name={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                  type="radio"
                                />
                              </td>
                              <td>
                                <Form.Check
                                  value="75"
                                  name={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                  type="radio"
                                />
                              </td>
                              <td>
                                <Form.Check
                                  value="50"
                                  name={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                  type="radio"
                                />
                              </td>
                              <td>
                                <Form.Check
                                  value="25"
                                  name={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                  type="radio"
                                />
                              </td>
                              <td>
                                <Form.Check
                                  value="Change"
                                  name={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  id={
                                    position === "Front Right"
                                      ? "tire_trade_front_right"
                                      : position === "Front Left"
                                      ? "tire_trade_front_left"
                                      : position === "Rear Left"
                                      ? "tire_trade_rear_left"
                                      : "tire_trade_rear_right"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                  type="radio"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Tire field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="tire">
                      <Form.Label>Tire*</Form.Label>
                      <div>
                        <Form.Check
                          label="Fix Flat"
                          name="tire"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Rotation Done"
                          value="Rotation Done"
                          name="tire"
                          id="tire"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Rotation Next Time"
                          value="Rotation Next Time"
                          name="tire"
                          id="tire"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Not Required"
                          value="Not Required"
                          name="tire"
                          id="tire"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="Other"
                          name="tire"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}

              {currentStep === 4 && (
                <>
                  {/* Other Fluids Level section */}
                  <div className="col-md-12 mb-3">
                    <h5>Other Fluids Level</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Good</th>
                            <th>Low</th>
                            <th>Very Low</th>
                          </tr>
                        </thead>
                        <tbody>
                          {["Break Fluid", "Coolant", "Windshield washer"].map(
                            (fluid) => (
                              <tr key={fluid}>
                                <td>{fluid}</td>
                                <td>
                                  <Form.Check
                                    value="Good"
                                    name={
                                      fluid === "Break Fluid"
                                        ? "break_fluid"
                                        : fluid === "Coolant"
                                        ? "coolant_fluid"
                                        : "windshield_washer"
                                    }
                                    id={
                                      fluid === "Break Fluid"
                                        ? "break_fluid"
                                        : fluid === "Coolant"
                                        ? "coolant_fluid"
                                        : "windshield_washer"
                                    }
                                    className="form-control "
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                    }}
                                    type="radio"
                                  />
                                </td>
                                <td>
                                  <Form.Check
                                    value="Low"
                                    name={
                                      fluid === "Break Fluid"
                                        ? "break_fluid"
                                        : fluid === "Coolant"
                                        ? "coolant_fluid"
                                        : "windshield_washer"
                                    }
                                    id={
                                      fluid === "Break Fluid"
                                        ? "break_fluid"
                                        : fluid === "Coolant"
                                        ? "coolant_fluid"
                                        : "windshield_washer"
                                    }
                                    className="form-control "
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                    }}
                                    type="radio"
                                  />
                                </td>
                                <td>
                                  <Form.Check
                                    value="Very Low"
                                    name={
                                      fluid === "Break Fluid"
                                        ? "break_fluid"
                                        : fluid === "Coolant"
                                        ? "coolant_fluid"
                                        : "windshield_washer"
                                    }
                                    id={
                                      fluid === "Break Fluid"
                                        ? "break_fluid"
                                        : fluid === "Coolant"
                                        ? "coolant_fluid"
                                        : "windshield_washer"
                                    }
                                    className="form-control "
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                    }}
                                    type="radio"
                                  />
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Replaced Tire field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="replacedTire">
                      <Form.Label>Replaced Tire*</Form.Label>
                      <div>
                        <Form.Check
                          label="No"
                          value="No"
                          name="replace_tire"
                          id="replace_tire"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Front Left"
                          value="Front Left"
                          name="replace_tire"
                          id="replace_tire"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Front Right"
                          value="Front Right"
                          name="replace_tire"
                          id="replace_tire"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Rear Left"
                          value="Rear Left"
                          name="replace_tire"
                          id="replace_tire"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Rear Right"
                          value="Rear Right"
                          name="replace_tire"
                          id="replace_tire"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* Fender liners field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="fenderLiners">
                      <Form.Label>
                        Fender liners / Engine Liners Etc*
                      </Form.Label>
                      <div>
                        <Form.Check
                          label="All Liners Good"
                          value="All Liners Good"
                          name="fender_liners"
                          id="fender_liners"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Liners Adjusted"
                          value="Liners Adjusted"
                          name="fender_liners"
                          id="fender_liners"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Liner changed"
                          value="Liner changed"
                          name="fender_liners"
                          id="fender_liners"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}
              {currentStep === 5 && (
                <>
                  {/* City Sticker field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="citySticker">
                      <Form.Label>City Sticker*</Form.Label>
                      <div>
                        <Form.Check
                          label="Mount Prospect (April-2023)"
                          value="Mount Prospect (April-2023)"
                          name="city_stiker"
                          id="city_stiker"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Park Ridge (June-2023)"
                          value="Park Ridge (June-2023)"
                          name="city_stiker"
                          id="city_stiker"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Roselle (September-2022)"
                          value="Roselle (September-2022)"
                          name="city_stiker"
                          id="city_stiker"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="No Sticker (Come to Office)"
                          value="No Sticker (Come to Office)"
                          name="city_stiker"
                          id="city_stiker"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* Heating / AC Check field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="heatingACCheck">
                      <Form.Label>Heating / AC Check*</Form.Label>
                      <div>
                        <Form.Check
                          label="Working Good"
                          value="Working Good"
                          name="ac_check"
                          id="ac_check"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Need Attention"
                          value="Need Attention"
                          name="ac_check"
                          id="ac_check"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* RESET MAINTENANCE field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="resetMaintenance">
                      <Form.Label>RESET MAINTENANCE*</Form.Label>
                      <div>
                        <Form.Check
                          label="Done"
                          value="Done"
                          name="reset_maintainance"
                          id="reset_maintainance"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="Not Done"
                          value="Not Done"
                          name="reset_maintainance"
                          id="reset_maintainance"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* ODO Meter field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="odoMeter">
                      <Form.Label>ODO Meter*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="ODO Meter reading"
                        id="code_on_dashboard"
                        name="code_on_dashboard"
                        className="form-control "
                      />
                      <small className="text-muted">
                        Please check that its ODO meter not the Trip A or Trip B
                      </small>
                    </Form.Group>
                  </div>

                  {/* Last 5 numbers of IPASS field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="ipassNumbers">
                      <Form.Label>Last 5 numbers of IPASS*</Form.Label>
                      <Form.Control
                        type="text"
                        id="last_5_digit_ipass"
                        name="last_5_digit_ipass"
                        placeholder="Last 5 numbers"
                        className="form-control "
                      />
                      <small className="text-muted">
                        Some time pictures are not clear, so put last 5 numbers
                        to verify the IPASS.
                      </small>
                    </Form.Group>
                  </div>

                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="dashboardLights">
                      <Form.Label>DASHBOARD Lights & Others*</Form.Label>
                      <div>
                        {[
                          "NO DASH LIGHT",
                          "CHK ENG",
                          "TIRE WARNING",
                          "CODES",
                          "Check Horn working good",
                          "Check phone Charging good",
                        ].map((label) => (
                          <Form.Check
                            key={label}
                            label={label}
                            value={label}
                            name="dashboard_light"
                            id="dashboard_light"
                            type="radio"
                            checked={selectedLight === label}
                            onChange={() => handleChange1(label)}
                          />
                        ))}

                        {/* "Other" option */}
                        <Form.Check
                          label="Other"
                          name="dashboard_light"
                          id="dashboard_light"
                          type="radio"
                          checked={selectedLight === "Other"}
                          onChange={() => handleChange1("Other")}
                        />

                        {/* Show input field if "Other" is selected */}
                        {selectedLight === "Other" && (
                          <Form.Control
                            type="text"
                            placeholder="Enter custom issue"
                            name="dashboard_light"
                            id="dashboard_light"
                            value={otherValue4}
                            onChange={(e) => setOtherValue4(e.target.value)}
                            className="mt-2"
                          />
                        )}
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}
              {currentStep === 6 && (
                <>
                  {/* Wiper Blades section */}
                  <div className="col-md-12 mb-3">
                    <h5>Wiper Blades</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Good</th>
                            <th>Changed</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            "Front Driver Side",
                            "Front Pass. side",
                            "Rear (if any)",
                            "Wiper Working",
                          ].map((wiper) => (
                            <tr key={wiper}>
                              <td>{wiper}</td>
                              <td>
                                <Form.Check
                                  value="Good"
                                  name={
                                    wiper === "Front Driver Side"
                                      ? "wiper_blade_front_driver"
                                      : wiper === "Front Pass. side"
                                      ? "wiper_blade_front_passenger"
                                      : wiper === "Rear (if any)"
                                      ? "wiper_blade_rear"
                                      : "wiper_working"
                                  }
                                  id={
                                    wiper === "Front Driver Side"
                                      ? "wiper_blade_front_driver"
                                      : wiper === "Front Pass. side"
                                      ? "wiper_blade_front_passenger"
                                      : wiper === "Rear (if any)"
                                      ? "wiper_blade_rear"
                                      : "wiper_working"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                  type="radio"
                                />
                              </td>
                              <td>
                                <Form.Check
                                  value="Changed"
                                  name={
                                    wiper === "Front Driver Side"
                                      ? "wiper_blade_front_driver"
                                      : wiper === "Front Pass. side"
                                      ? "wiper_blade_front_passenger"
                                      : wiper === "Rear (if any)"
                                      ? "wiper_blade_rear"
                                      : "wiper_working"
                                  }
                                  id={
                                    wiper === "Front Driver Side"
                                      ? "wiper_blade_front_driver"
                                      : wiper === "Front Pass. side"
                                      ? "wiper_blade_front_passenger"
                                      : wiper === "Rear (if any)"
                                      ? "wiper_blade_rear"
                                      : "wiper_working"
                                  }
                                  className="form-control "
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                  type="radio"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Code on Dashboard field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="dashboardCode">
                      <Form.Label>Code on Dashboard*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter code"
                        id="code_on_dashboard"
                        name="code_on_dashboard"
                        className="form-control "
                      />
                      <small className="text-muted">
                        Take pictures of the codes reading
                      </small>
                    </Form.Group>
                  </div>

                  {/* Remarks for Code field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="codeRemarks">
                      <Form.Label>
                        Remarks for the Code on Dashboard*
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter remarks"
                        id="remark_dashboard_code"
                        name="remark_dashboard_code"
                        className="form-control "
                      />
                    </Form.Group>
                  </div>

                  {/* Damage field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="damage">
                      <Form.Label>Damage (if any)*</Form.Label>
                      <div>
                        <Form.Check
                          label="No Damage noticed (Skip Pictures)"
                          value="No Damage noticed"
                          name="damage_status"
                          type="radio"
                          checked={damage === "No Damage noticed"}
                          onChange={handleDamageChange}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="There is some Damage (Take Pictures)"
                          value="There is some Damage"
                          name="damage_status"
                          type="radio"
                          checked={damage === "There is some Damage"}
                          onChange={handleDamageChange}
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                      </div>

                      {damage === "There is some Damage" && (
                        <div className="mt-3">
                          <Form.Label>Upload Pictures of the Damage</Form.Label>
                          <div
                            className="upload_img_div"
                            onClick={handleUploadClick}
                          >
                            Upload Image
                          </div>

                          <input
                            id="fileInput"
                            style={{ display: "none" }}
                            name="damage_image"
                            type="file"
                            multiple
                            onChange={handleFileChange}
                          ></input>
                          {files && (
                            <div className="mt-3">
                              <p>Selected Files:</p>
                              <ul>
                                {Array.from(files).map((file, index) => (
                                  <li key={index}>{file.name}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  {/* Seat Cover field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="seat_cover">
                      <Form.Label>Seat Cover installed?</Form.Label>
                      <div>
                        <Form.Check
                          label="Yes"
                          value="yes"
                          name="seat_cover"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                        <Form.Check
                          label="No"
                          value="no"
                          name="seat_cover"
                          type="radio"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* Check Driver has Oil bottles field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="driverOilBottles">
                      <Form.Label>Check Driver has Oil bottles*</Form.Label>
                      <div>
                        <Form.Check
                          label="2 Qt"
                          value="2 Qt"
                          name="driver_oil_bottles"
                          id="driver_oil_bottles"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="3 Qt"
                          value="3 Qt"
                          name="driver_oil_bottles"
                          id="driver_oil_bottles"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="NO OIL REQ"
                          value="NO OIL REQ"
                          name="driver_oil_bottles"
                          id="driver_oil_bottles"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* Snow Brush field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="snowBrush">
                      <Form.Label>Snow Brush*</Form.Label>
                      <div>
                        <Form.Check
                          label="Yes, Has Snow Brush in Car"
                          value='"Yes, Has Snow Brush in Car"'
                          name="snow_brush"
                          id="snow_brush"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="No, Snow Brush Added"
                          value="No, Snow Brush Added"
                          name="snow_brush"
                          id="snow_brush"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                      </div>
                    </Form.Group>
                  </div>

                  {/* Verify 2nd Key field */}
                  <div className="col-md-6 mb-3">
                    <Form.Group controlId="verifySecondKey">
                      <Form.Label>
                        Come to office to verify the 2nd Key.
                      </Form.Label>
                      <div>
                        <Form.Check
                          label="Yes"
                          value="Yes"
                          name="office_verify"
                          id="office_verify"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                        <Form.Check
                          label="No"
                          value="No"
                          name="office_verify"
                          id="office_verify"
                          className="form-control "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="radio"
                        />
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}
              {currentStep === 7 && (
                <>
                  {/* Remarks / Additional details field */}
                  <div className="col-md-12 mb-3">
                    <Form.Group controlId="remarks">
                      <Form.Label>
                        Remarks (Please mention details of damage and whatever
                        extra you did to the car)*
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Add additional details..."
                        id="remark"
                        name="remark"
                        className="form-control "
                      />
                    </Form.Group>
                  </div>

                  {/* Details of Repair field */}
                  <div className="col-md-12 mb-3">
                    <Form.Group controlId="repairDetails">
                      <Form.Label>Details of Repair done.</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter repair details..."
                        id="details_for_repair"
                        name="details_for_repair"
                        className="form-control "
                      />
                    </Form.Group>
                  </div>

                  {/* Notes for Future field */}
                  <div className="col-md-12 mb-3">
                    <Form.Group controlId="futureNotes">
                      <Form.Label>Notes for Future</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter notes for future..."
                        id="notes_for_future"
                        name="notes_for_future"
                        className="form-control "
                      />
                    </Form.Group>
                  </div>
                </>
              )}
            </div>
            {errors}
            <div className="ftter_sav_cncl_btn">
              {currentStep > 0 && (
                <Button
                  variant="primary"
                  onClick={handlePrevious}
                  className="mt-3 cencelbttn"
                >
                  <BiArrowBack /> Back
                </Button>
              )}

              {currentStep === 7 ? (
                <>
                  <Button
                    variant="primary"
                    onClick={handleShowMainModal}
                    className="mt-3 cencelbttn"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() =>
                      handleSaveChangesdynamic(
                        "FormData",
                        maintainance_car_data
                      )
                    }
                    // onClick={handleShowMainModal}
                    className="mt-3"
                  >
                    Save
                  </Button>
                </>
              ) : (
                <Button
                  variant="primary"
                  onClick={() =>
                    handleSaveChangesdynamic("FormData", maintainance_car_data)
                  }
                  // onClick={handleNext} className="mt-3"
                >
                  Next
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MaintenaceDataModal;
